import { render, staticRenderFns } from "./ImportDataRevenueDialog.vue?vue&type=template&id=5c279d34&scoped=true"
import script from "./ImportDataRevenueDialog.vue?vue&type=script&lang=js"
export * from "./ImportDataRevenueDialog.vue?vue&type=script&lang=js"
import style0 from "./ImportDataRevenueDialog.vue?vue&type=style&index=0&id=5c279d34&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c279d34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c279d34')) {
      api.createRecord('5c279d34', component.options)
    } else {
      api.reload('5c279d34', component.options)
    }
    module.hot.accept("./ImportDataRevenueDialog.vue?vue&type=template&id=5c279d34&scoped=true", function () {
      api.rerender('5c279d34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/TuitionManagement/dialog/ImportDataRevenueDialog.vue"
export default component.exports